export const messages = {
  panel: {
    title: {
      id: 'personalDataExport.Panel.Title',
      defaultMessage: 'Personal Data',
    },
    subTitles: {
      primary: {
        id: 'personalDataExport.Panel.SubTitles.Primary',
        defaultMessage: `Download a copy of your personal data. This includes registration information, 
          personal contacts, secure messages and questionnaire responses.`,
      },
      secondary: {
        id: 'personalDataExport.Panel.SubTitles.Secondary',
        defaultMessage: `The exported data is provided in an XML file which can be 
          opened by a text editor.`,
      },
    },
    buttons: {
      download: {
        id: 'personalDataExport.Buttons.Download',
        defaultMessage: 'Download Personal Data',
      },
    },
  },
};
